<template>
  <div>
    <div class="manager-panel">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col style="flex: 1">
          <a-dropdown :trigger="['click']" v-model="seachMenuView">
            <a-input-search
              class="ant-dropdown-link"
              placeholder="Search"
              :value="sortActive"
            />
            <a-menu slot="overlay" style="background-color: #fafafa">
              <a-form
                id="my_form_search_styl"
                layout="vertical"
                style="padding: 15px"
              >
                <a-menu-item key="1">
                  <a-form-item
                    label="Specjalista PPC"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 8 }"
                  >
                    <a-select
                      v-model="sort.selectWorker"
                      style="width: 170px"
                      show-search
                      placeholder="Select"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      >
                      <a-select-option
                        v-for="user in selectAssignedList"
                        :value="user.id"
                        :key="user.id"
                        >{{ user.name }}</a-select-option
                      >
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="(el) => clearSelect('selectWorker')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="2">
                  <a-form-item
                    label="Data Month"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 8 }"
                  >
                    <a-month-picker
                      v-model="sort.selectData"
                      style="width: 170px; margin-right: auto"
                      placeholder="Select month"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-form-item
                  style="text-align: center"
                  :label-col="{ span: 0 }"
                  :wrapper-col="{ span: 24 }"
                >
                  <a-button type="primary" @click="updateMediaList">{{
                    $t("Search")
                  }}</a-button>
                </a-form-item>
              </a-form>
            </a-menu>
          </a-dropdown>
        </a-col>
      </a-row>
    </div>
    <a-table
      :scroll="{ x: 1400, y: 700 }"
      :columns="columnsMediaListTable"
      :data-source="MediaListSource"
      bordered
    >
      <template
        v-for="col in ['plan', 'komentarz']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable == 1"
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.key, col)"
          />
          <template v-else>{{ text }}</template>
        </div>
      </template>
      <template slot="project" slot-scope="text, record">
        <template>
          <a
            target="_blank"
            :href="'https://' + domain + '/crm/deal/details/' + record.id + '/'"
            >{{ text }}</a
          >
        </template>
      </template>
      <template slot="kontrahent" slot-scope="text">
        <div>
          <template style="width: 160px">{{ searchCompany(text) }}</template>
        </div>
      </template>
      <template slot="typPrzychodu" slot-scope="text">
        <div>
          <template>{{ searchTypeArrival(text) }}</template>
        </div>
      </template>
      <template slot="platnik" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable == 1"
            style="width: 160px"
            :value="text"
            @change="
              (value) => {
                handleChange(value, record.key, 'platnik');
              }
            "
          >
            <a-select-option
              v-for="platnik in selectPlatnik"
              :value="platnik.id"
              :key="platnik.id"
              >{{ platnik.name }}</a-select-option
            >
          </a-select>
          <!--          <a-select-->
          <!--            v-else-if="record.editable == 2"-->
          <!--            style="width: 160px"-->
          <!--            :value="text"-->
          <!--            @change="(value) => {handleChange(value, record.key, 'platnik')}"-->
          <!--          >-->
          <!--            <a-select-option-->
          <!--              v-for="platnik in selectPlatnik"-->
          <!--              :value="platnik.id"-->
          <!--              :key="platnik.id"-->
          <!--            >{{platnik.name}}</a-select-option>-->
          <!--          </a-select>-->
          <template v-else>{{ searchPlatnik(text) }}</template>
        </div>
      </template>
      <template slot="specjalista" slot-scope="text">
        <div>
          <template>{{ searchUser(text) }}</template>
        </div>
      </template>
      <template slot="opiekunCS" slot-scope="text">
        <div>
          <!--          <a-select-->
          <!--            v-if="((record.editable == 1) && (!(text) || (record.status == 0)))"-->
          <!--            show-search-->
          <!--            placeholder="Select"-->
          <!--            option-filter-prop="children"-->
          <!--            :filter-option="filterOption"-->
          <!--            style="width: 140px"-->
          <!--            @change="(value) => {handleChange(value, record.key, 'opiekunCS')}"-->
          <!--          >-->
          <!--            <a-select-option-->
          <!--              v-for="specjalista in selectResponsibleList"-->
          <!--              :value="specjalista.id"-->
          <!--              :key="specjalista.id"-->
          <!--            >{{specjalista.name}}</a-select-option>-->
          <!--          </a-select>-->
          <template>{{ searchUser(text) }}</template>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div v-if="record.status != 3" class="editable-row-operations">
          <span
            v-if="record.editable == 1"
            style="display: flex; flex-direction: row"
          >
            <a
              v-if="record.checkAllDateList"
              @click="
                () => {
                  editMediaListItem(record);
                }
              "
              style="width: 20px; margin-right: 10px"
            >
              <a-icon type="save" />
            </a>
            <a-popconfirm
              title="Sure to cancel?"
              @confirm="() => cancel(record.key)"
              style="width: 20px"
            >
              <a>
                <a-icon type="redo" />
              </a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a
              :disabled="!(editingKey == '' && statusEdit)"
              @click="() => edit(record.key)"
            >
              <a-icon type="edit" />
            </a>
          </span>
        </div>
        <div v-else class="editable-row-operations"></div>
      </template>
      <template slot="plan" slot-scope="text, record">
        <a-input
          v-if="record.editable == 1 && !record.blocked"
          style="margin: -5px 0"
          :value="text"
          @change="(e) => handleChange(e.target.value, record.key, 'plan')"
        />
        <template v-else>{{ text }}</template>
      </template>
    </a-table>
  </div>
</template>

<script>
import {
  getMediaListSort,
  postMediaListItem,
  postEditMediaListItem,
} from "@/requestFunc";
import moment from "moment";

export default {
  name: "addMediaListTable",
  props: ["settings", "USER_ACTIVE", "user_setup", "domain"],
  data() {
    return {
      MediaListSource: [],
      dealList: [],
      columnsMediaListTable: [
        {
          title: this.$t("Project"),
          dataIndex: "project",
          scopedSlots: { customRender: "project" },
          width: 150,
        },
        {
          title: "Kontrahent",
          dataIndex: "kontrahent",
          scopedSlots: { customRender: "kontrahent" },
          width: 260,
        },
        {
          title: "Typ przychodu",
          dataIndex: "typPrzychodu",
          scopedSlots: { customRender: "typPrzychodu" },
          width: 180,
        },
        {
          title: this.$t("Płatnik"),
          dataIndex: "platnik",
          scopedSlots: { customRender: "platnik" },
          width: 180,
        },
        {
          title: "Specjalista PPC",
          dataIndex: "specjalista",
          scopedSlots: { customRender: "specjalista" },
          width: 170,
        },
        {
          title: "Opiekun CS",
          dataIndex: "opiekunCS",
          scopedSlots: { customRender: "opiekunCS" },
          width: 170,
        },
        {
          title: "Plan",
          dataIndex: "plan",
          scopedSlots: { customRender: "plan" },
          width: 100,
        },
        {
          title: "Komentarz",
          dataIndex: "komentarz",
          scopedSlots: { customRender: "komentarz" },
          width: 160,
        },
        {
          title: "",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 80,
        },
      ],
      cacheMediaListSource: [],
      editingKey: "",
      countMediaList: "",
      sort: {
        selectWorker: "",
        selectData: "",
        selectYear: "",
        selectMonth: "",
      },
      sortActive: "",
      selectResponsibleList: [],
      selectAssignedList: [],
      selectTypPrzychoduList: [],
      selectOpiekunCSList: [],
      selectPlatnik: [],
      stateAddButton: false,
      seachMenuView: false,
      statusEdit: false,
      typeArrival: [],
      typeSelection: [],
    };
  },
  computed: {
    selectKontrahentList: function () {
      return this.settings.company.map((company) => ({
        id: company.ID,
        name: company.TITLE,
      }));
    },
  },
  methods: {
    updateMediaList() {
      let sort =
        this.sort.selectData != null
          ? {
              year: moment(this.sort.selectData).format("YYYY"), //year: this.sort.selectYear,
              month: moment(this.sort.selectData).format("M"), //month: this.sort.selectMonth
            }
          : {};
      if (this.sort.selectWorker != "") {
        sort.userId = this.sort.selectWorker;
      }
      this.editTableDate = this.sort.selectData;
      this.editingKey = "";
      this.stateAddButton = false;
      this.sortActive = this.setSortActive(this.sort);
      getMediaListSort(sort)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);

          this.dealList = item.project;
          this.MediaListSource = [];

          this.typeSelection = item.typeSelection
            ? item.typeSelection.map((el) => {
                let result = {};
                if (el.VALUE == "FVS PPC AdWords Media") {
                  result = { name: "UF_CRM_ADV_MEDIA", id: el.ID };
                }
                if (el.VALUE == "FVS PPC FB Media") {
                  result = { name: "UF_CRM_FB_MEDIA", id: el.ID };
                }
                if (el.VALUE == "FVS PPC Inni Wyd. Media") {
                  result = { name: "UF_CRM_INNI_MEDIA", id: el.ID };
                }
                if (el.VALUE == "FVS SM Media") {
                  result = { name: "UF_CRM_SM_MEDIA", id: el.ID };
                }
                return result;
              })
            : {};

          this.typeArrival = item.TypArrival.map((el) => {
            let result = {};
            if (el.VALUE == "FVS PPC AdWords Media") {
              result = { name: "UF_CRM_ADV_MEDIA", id: el.ID };
            }
            if (el.VALUE == "FVS PPC FB Media") {
              result = { name: "UF_CRM_FB_MEDIA", id: el.ID };
            }
            if (el.VALUE == "FVS PPC Inni Wyd. Media") {
              result = { name: "UF_CRM_INNI_MEDIA", id: el.ID };
            }
            if (el.VALUE == "FVS SM Media") {
              result = { name: "UF_CRM_SM_MEDIA", id: el.ID };
            }
            return result;
          });
          let indexKey = 0;
          let checkCurrentDate = false;
          let currentDateUser = moment();
          let filteDate = moment(this.sort.selectData);

          if (moment(currentDateUser).format("D") < 28) {
            currentDateUser.set("date", 1);
            filteDate.set("date", 1);

            let d1 =
              Number(moment(currentDateUser).format("YYYY") * 100) +
              Number(moment(currentDateUser).format("M"));
            let d2 =
              Number(moment(filteDate).format("YYYY") * 100) +
              Number(moment(filteDate).format("M"));
            if (d1 < d2) {
              checkCurrentDate = true;
            }
          } else {
            currentDateUser.set("date", 1);
            filteDate.set("date", 1);
            filteDate.subtract(1, "month");

            let d1 =
              Number(moment(currentDateUser).format("YYYY") * 100) +
              Number(moment(currentDateUser).format("M"));
            let d2 =
              Number(moment(filteDate).format("YYYY") * 100) +
              Number(moment(filteDate).format("M"));
            if (d1 < d2) {
              checkCurrentDate = true;
            }
          }
          for (let key in this.dealList) {
            let m1 =
              Number(
                moment(this.dealList[key].DATE_CREATE).format("YYYY") * 100
              ) + Number(moment(this.dealList[key].DATE_CREATE).format("M"));
            let m2 =
              Number(moment(this.sort.selectData).format("YYYY") * 100) +
              Number(moment(this.sort.selectData).format("M"));

            if (m1 <= m2 && checkCurrentDate) {
              for (let t_key in this.typeSelection) {
                if (this.dealList[key].UF_CRM_1599225908) {
                  if (
                    this.dealList[key].UF_CRM_1599225908.find(
                      (el) => el == this.typeSelection[t_key].id
                    ) &&
                    this.dealList[key][this.typeSelection[t_key].name] ==
                      this.sort.selectWorker &&
                    this.dealList[key].UF_CRM_1599224076 != null
                  ) {
                    indexKey++;
                    let idPlatnik = "";
                    if (this.dealList[key]["typePlatnik"]) {
                      if (
                        !(
                          this.dealList[key]["typePlatnik"][
                            this.typeSelection[t_key].name
                          ] == ""
                        )
                      ) {
                        idPlatnik = this.dealList[key]["typePlatnik"][
                          this.typeSelection[t_key].name
                        ];
                      }
                    }
                    this.MediaListSource.push({
                      key: indexKey,
                      id: this.dealList[key].ID,
                      project: this.dealList[key].TITLE,
                      kontrahent: this.dealList[key].COMPANY_ID,
                      typPrzychodu: this.typeArrival.find(
                        (el) => el.name == this.typeSelection[t_key].name
                      ).id,
                      platnik: idPlatnik,
                      specjalista: this.dealList[key][
                        this.typeSelection[t_key].name
                      ],
                      opiekunCS: this.dealList[key].UF_CRM_1599224076,
                      plan: "",
                      komentarz: "",
                      status: 0,
                      typeArrival: this.typeSelection[t_key].name,
                      blocked: !checkCurrentDate,
                      editable: 0,
                    });
                  }
                }
              }
            }
            if (this.dealList[key].info) {
              for (let i_key in this.dealList[key].info) {
                let info = this.dealList[key].info[i_key];
                let changeMediaList = this.MediaListSource.find((el) => {
                  return (
                    el.id == info.dealID &&
                    el.typeArrival == info.TYPE_ARRIVAL_DEAL
                  );
                });
                if (changeMediaList) {
                  if (info.ASSIGNED_BY_ID == this.sort.selectWorker) {
                    changeMediaList.project = info.DEAL_TITLE;
                    changeMediaList.kontrahent = info.DEAL_COMPANY_ID;
                    changeMediaList.platnik = info.payer;
                    changeMediaList.specjalista = info.ASSIGNED_BY_ID;
                    changeMediaList.opiekunCS = info.responsible;
                    changeMediaList.plan = info.plan;
                    changeMediaList.komentarz = info.DEAL_COMMENTS;
                    changeMediaList.status = 1;
                    changeMediaList.blocked = !checkCurrentDate;
                    changeMediaList.editable = 0;
                  } else {
                    this.MediaListSource.splice(
                      this.MediaListSource.indexOf(changeMediaList),
                      1
                    );
                  }
                } else {
                  if (info.ASSIGNED_BY_ID == this.sort.selectWorker) {
                    indexKey++;
                    this.MediaListSource.push({
                      key: indexKey,
                      id: info.dealID,
                      project: info.DEAL_TITLE,
                      kontrahent: info.DEAL_COMPANY_ID,
                      typPrzychodu: info.typeArrival,
                      platnik: info.payer,
                      specjalista: info.ASSIGNED_BY_ID,
                      opiekunCS: info.responsible,
                      plan: info.plan,
                      komentarz: info.DEAL_COMMENTS,
                      status: 1,
                      typeArrival: info.TYPE_ARRIVAL_DEAL,
                      blocked: !checkCurrentDate,
                      editable: 0,
                    });
                  }
                }
              }
            }
          }

          for (let key in item.delMedia) {
            indexKey++;
            let delMediaList = item.delMedia[key];
            this.MediaListSource.push({
              key: indexKey,
              id: delMediaList.dealID,
              project: delMediaList.DEAL_TITLE,
              kontrahent: delMediaList.DEAL_COMPANY_ID,
              typPrzychodu: delMediaList.typeArrival,
              platnik: delMediaList.payer,
              specjalista: delMediaList.ASSIGNED_BY_ID,
              opiekunCS: delMediaList.responsible,
              plan: delMediaList.plan,
              komentarz: delMediaList.DEAL_COMMENTS,
              status: 3,
              editable: 0,
              blocked: true,
              typeArrival: delMediaList.TYPE_ARRIVAL_DEAL,
            });
          }
          this.countMediaList = this.MediaListSource.length;
          this.setTypPrzychodu(item.TypArrival);
          this.setPlatnik(item.Platnik);
          this.seachMenuView = false;
        })
        .fail((e) => {
          console.error(e)
          this.$message.error(this.$t("Error loading document"));
        });
      BX24.fitWindow();
    },
    setSortActive(sort) {
      let sortActive = "";
      if (sort.selectWorker != "") {
        if (this.sort.selectData != "" && this.sort.selectData != null) {
          sortActive =
            this.searchUser(sort.selectWorker) +
            " - " +
            moment(sort.selectData).format("YYYY") +
            "-" +
            moment(sort.selectData).format("MM");
        } else {
          sortActive = this.searchUser(sort.selectWorker);
        }
      } else {
        if (this.sort.selectData != "" && this.sort.selectData != null) {
          sortActive =
            moment(sort.selectData).format("YYYY") +
            "-" +
            moment(sort.selectData).format("MM");
        }
      }
      return sortActive;
    },
    setTypPrzychodu(typArrival) {
      this.selectTypPrzychoduList = typArrival.map((el) => ({
        id: el.ID,
        name: el.VALUE,
      }));
    },
    setPlatnik(platnik) {
      this.selectPlatnik = platnik.map((el) => ({ id: el.ID, name: el.VALUE }));
    },
    postMediaListItem: function (record) {
      let project = {
        PROJECT_TITLE: record.project,
        COMPANY_ID: record.kontrahent,
        UF_CRM_TYPE_ARRIVAL: record.typPrzychodu,
        PLATNIK: record.platnik,
        ASSIGNED_BY_ID: record.specjalista,
        UF_CRM_1599224076: record.opiekunCS,
        PLAN: record.plan,
        COMMENT: record.komentarz,
      };
      let data = {
        year: moment(this.sort.selectData).format("YYYY"),
        month: moment(this.sort.selectData).format("M"),
      };
      postMediaListItem(project, data)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);
          this.handleChange(item.ID, record.key, "id");
          this.save(record.key);
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    editMediaListItem: function (record) {
      let project = {
        ID: record.id,
        PROJECT_TITLE: record.project,
        COMPANY_ID: record.kontrahent,
        UF_CRM_TYPE_ARRIVAL: record.typPrzychodu,
        PLATNIK: record.platnik,
        ASSIGNED_BY_ID: record.specjalista,
        UF_CRM_1599224076: record.opiekunCS,
        PLAN: record.plan,
        COMMENT: record.komentarz,
        type_Arrival_deal: record.typeArrival,
      };
      record.status = 1;
      let date = {
        year: moment(this.sort.selectData).format("YYYY"),
        month: moment(this.sort.selectData).format("M"),
      };
      postEditMediaListItem({ project, date })
        .done((data) => {
          data
          this.$message.info(this.$t("Download complete!"));
          // let item = data == "" ? {} : JSON.parse(data);
          this.save(record.key);
        })
        .fail((e) => {
          console.error(e)
          this.$message.error(this.$t("Error loading document"));
        });
    },

    searchTypeArrival: function (idTypeArrival) {
      let typeArrival = this.selectTypPrzychoduList.find((type) => {
        return type.id == idTypeArrival;
      });
      return typeArrival ? typeArrival.name : "";
    },
    searchPlatnik: function (idPlatnik) {
      let platnik = this.selectPlatnik.find((type) => {
        return type.id == idPlatnik;
      });
      return platnik ? platnik.name : "";
    },
    searchCompany: function (idCompany) {
      let company = this.settings.company.find((company) => {
        return company.ID == idCompany;
      });
      return company ? company.TITLE : "";
    },
    searchUser: function (idUser) {
      let user = this.settings.data_user.find((user) => {
        return user.ID == idUser;
      });
      return user ? user.LAST_NAME + " " + user.NAME : "";
    },

    selectResponsibleListUpdate: function () {
      if (this.user_setup.mediaResponsible) {
        this.selectResponsibleList = this.user_setup.mediaResponsible.map(
                (idUser) => {
                  let user = this.settings.data_user.find((el) => el.ID == idUser);
                  return {
                    id: user.ID,
                    name: user.LAST_NAME + " " + user.NAME,
                  };
                }
        );
      }
    },
    selectAssignedListUpdate: function () {
      if (this.user_setup.mediaAssigned) {
        this.selectAssignedList = this.user_setup.mediaAssigned.map((idUser) => {
          let user = this.settings.data_user.find((el) => el.ID == idUser);
          return {
            id: user.ID,
            name: user.LAST_NAME + " " + user.NAME,
          };
        });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    clearSelect: function (nameSelect) {
      this.sort[nameSelect] = "";
    },

    handleChange(value, key, column) {
      const newData = [...this.MediaListSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.MediaListSource = newData;
      }
      target.checkAllDateDeal =
        Boolean(target.project) &&
        Boolean(target.specjalista) &&
        Boolean(target.opiekunCS);
      target.checkAllDateList =
        target.checkAllDateDeal &&
        Boolean(target.kontrahent) &&
        Boolean(target.platnik) &&
        Boolean(target.typPrzychodu);
    },
    edit(key) {
      const newData = [...this.MediaListSource];
      const target = newData.find((item) => key === item.key);
      this.editingKey = key;
      this.stateAddButton = true;
      if (target) {
        target.editable = 1;
        this.cacheMediaListSource = this.MediaListSource.map((item) => ({
          ...item,
        }));
        // this.MediaListSource = newData;
      }
    },
    save(key) {
      const newData = [...this.MediaListSource];
      const newCacheData = [...this.cacheMediaListSource];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      this.stateAddButton = false;
      if (target && targetCache) {
        target.editable = 0;
        this.MediaListSource = newData;
        Object.assign(targetCache, target);
        this.cacheMediaListSource = newCacheData;
      }
      this.editingKey = "";
    },
    cancel(key) {
      const newData = [...this.MediaListSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      this.stateAddButton = false;
      if (target) {
        Object.assign(
          target,
          this.cacheMediaListSource.filter((item) => key === item.key)[0]
        );
        target.editable = 0;
        this.MediaListSource = newData;
      }
    },
    cancelAdd(key) {
      const newData = [...this.MediaListSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      this.stateAddButton = false;
      if (target) {
        Object.assign(
          target,
          this.cacheMediaListSource.filter((item) => key === item.key)[0]
        );
        target.editable = 0;
        this.MediaListSource = newData;
        this.MediaListSource.pop();
      }
    },

    moment,

    changeStatusEdit: function () {
      let userEditActive = [...this.user_setup.mediaResponsible].concat([
        ...this.user_setup.mediaAssigned,
      ]);
      this.statusEdit = Boolean(
        userEditActive.find((el) => el == this.USER_ACTIVE.ID)
      );
    },
  },
  mounted() {
    this.changeStatusEdit();
    if (this.statusEdit) {
      this.sort.selectWorker = this.USER_ACTIVE.ID;
      this.sort.selectData = moment();
      this.sort.selectYear = moment().format("YYYY");
      this.sort.selectMonth = moment().format("M");
    } else {
      this.sort.selectData = moment();
      this.sort.selectYear = moment().format("YYYY");
      this.sort.selectMonth = moment().format("M");
    }
    this.selectResponsibleListUpdate();
    this.selectAssignedListUpdate();
    this.cacheMediaListSource = this.MediaListSource.map((item) => ({
      ...item,
    }));
    this.updateMediaList();
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.manager-panel {
  margin: 10px 0;
}
.manager-panel > * {
  margin: 5px 0px;
}
</style>
